var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.splitRoute(_vm.$route.name) === 'create')?_c('AppUsersCreate'):_vm._e(),(_vm.splitRoute(_vm.$route.name) === 'update')?_c('AppUsersUpdate'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }